import React from 'react';
import AppState from './appState/AppState';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from 'routes';
import 'styles/index.scss';

let App = () => {
	return (
		<AppState>
			<Router>
				<Routes />
			</Router>
		</AppState>
	);
};

export default App;
